// extracted by mini-css-extract-plugin
module.exports = {"worksDetailThumbnailContainer":"WorksDetailFooterProductFirst_worksDetailThumbnailContainer__Bocc5"};